var _filter, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgWave2InvertedShadow = function SvgWave2InvertedShadow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 200",
    filter: "url(#wave-2-inverted-shadow_svg__a)",
    enableBackground: "new 0 0 1600 200",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "wave-2-inverted-shadow_svg__a"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceAlpha",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComponentTransfer", null, /*#__PURE__*/React.createElement("feFuncA", {
    type: "linear",
    slope: 0.4
  })), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", null), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1432.2 156.2c-88.8 16.7-156 5.3-204-8.5s-147.1-62.2-223.1-73.9c-75.4-11.6-164 7.5-275 27.9S571 135.5 456 125.5c-119.7-10.4-224.7-52-294.4-73C67.1 24-10 55.5-10 55.5v10s77.1-31.5 171.6-3c69.7 21 174.7 62.6 294.4 73 115 10 163.1-3.4 274.1-23.8 111-20.4 199.6-39.5 275-27.9 76 11.7 175.1 60.1 223.1 73.9s115.2 25.2 204 8.5c91-17.1 124.8-34.2 177.8-24.2v-10c-53-10-86.8 7.1-177.8 24.2z"
  })));
};
export default SvgWave2InvertedShadow;